import { useEffect, useState } from "react";

import { Stack, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import ContentWrapper from "../../Components/organisms/T&CContentWrapper/ContentWrapper";

const TermsAndConditions = () => {
  const [searchParams] = useSearchParams();
  const [lang, setLang] = useState("");

  const setTermsAndConditionsLanguage = () => {
    const langParam = searchParams.get("lang");
    
    if (langParam === "es") {
      setLang("es");
    } else if(langParam === "sn") {
      setLang("sn");
    } else if(langParam === "tml") {
      setLang("tml");
    }else{
      setLang("en");
    }
  };

  useEffect(() => {
 
    setTermsAndConditionsLanguage();
    
  }, []);

  return (
    <Stack direction={"column"}>
      <Typography variant="h6" style={{ marginBottom: "24px" }}>
        <ContentWrapper lang={lang} />
      </Typography>
    </Stack>
  );
};

export default TermsAndConditions;
